
import img1 from '../assets/allcourses/allcourses5.jpg'
import img2 from '../assets/allcourses/allcourses3.jpg'
import img3 from '../assets/allcourses/allcourses4.jpg'
import img4 from '../assets/allcourses/allcourse6.jpg'
import img5 from '../assets/allcourses/allcourses2.jpg'



export const dataSet = [{
    banner: img1,
    title: "I.T. Project Management for Beginners: A Step-by-Step Guide",
    durationViews: '6hr 24min | 2.6K views',
    price: 'N10,000'
},
{
    banner: img2,
    title: 'Improve Communication: Speak Smoothly, Clearly & Confidently',
    durationViews: '6hr 24min | 2.6K views',
    price: 'N10,000'
},
{
    banner: img3,
    title: 'Statistics / Data Analysis in SPSS: Inferential Statistics',
    durationViews: '6hr 24min | 2.6K views',
    price: 'N10,000'
},
{
    banner: img4,
    title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
    durationViews: '6hr 24min | 2.6K views',
    price: 'N10,000'
},
{
    banner: img5,
    title: 'User Experience (UX): The Ultimate Guide to Usability and UX',
    durationViews: '6hr 24min | 2.6K views',
    price: 'N10,000'
},
] 